export default __webpack_public_path__ + "static/media/filtorsButton.1534131c.svg";